import { Fragment, useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import APIS from '../../constant/Endpoint';
import useGetHook from '../../customHooks/useGetHook';
import Card from '../Reusable/Card';
import Filter from './LocalFilter';
import StatusList from './StatusList';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
//@ts-ignore
import { AccessControl } from '@careinfo/permission-required';
import { useSessionStorage } from '@uidotdev/usehooks';
import GridCard from './GridCard';
import InternationalFilter from './InternationalFilter';
import usePermission from '../../customHooks/usePermission';

interface IFilterCombobox {
  id: string;
  name: string;
  [key: string]: any;
}

export interface IFilter {
  pickup_branch: IFilterCombobox | null;
  staff: IFilterCombobox | null;
  to_branch: IFilterCombobox | null;
  sender: IFilterCombobox | null;
  vendor: IFilterCombobox | null;
  date_range: string | null;
  receiver_country: IFilterCombobox | null;
  destination: IFilterCombobox | null;
}

const Dashboard = (props: any) => {
  const {
    currentUserProfile,
    gridData,
    handleClearCache,
    isLoading,
    clientType,
  } = props;
  const [localState, handleSetState] = useSessionStorage<IFilter>(
    'dashboard-overview-filter',
    {
      pickup_branch: null,
      to_branch: null,
      vendor: null,
      date_range: null,
      staff: null,
      sender: null,
      destination: null,
      receiver_country: null,
    }
  );
  const [activeCard, setActiveCard] = useState('');
  const [cardFilterParams, setCardFilterParams] = useState<any>({});

  const currentDateTime = new Date();
  const year = currentDateTime.getFullYear();
  const month = String(currentDateTime.getMonth() + 1).padStart(2, '0'); // Adding 1 because months are zero-based
  const startDay = String(currentDateTime.getDate()).padStart(2, '0');
  const endDay = String(currentDateTime.getDate()).padStart(2, '0');
  const startDate = `${year}-${month}-${startDay}`;
  const endDate = `${year}-${month}-${endDay}`;
  const [date, setDate] = useState(`${startDate}T00:00:00,${endDate}T23:59:00`);
  const {
    register,
    setValue,
    getValues,
    reset,
    clearErrors,
    watch,
    formState: { errors },
    control,
  } = useForm<IFilter>({
    defaultValues: {
      pickup_branch:
        localState?.pickup_branch ?? currentUserProfile?.default_branch,
      to_branch: localState?.to_branch ?? null,
      vendor: localState?.vendor ?? null,
      destination: localState?.destination ?? null,
      receiver_country: localState?.receiver_country ?? null,
      date_range: localState?.date_range ?? `${startDate},${endDate}`,
      staff: currentUserProfile?.is_superuser
        ? localState?.staff
        : currentUserProfile,
      sender: localState?.sender ?? null,
    } as IFilter,
  });

  const handleReset = () => {
    reset({
      pickup_branch: null,
      to_branch: null,
      vendor: null,
      date_range: null,
      staff: null,
      sender: null,
    });
  };

  const handleOnClickGrid = (key: string, name: string, invoice: boolean) => {
    setCardFilterParams(key);
    setActiveCard(name);
  };

  const filterParams = watch();

  useEffect(() => {
    handleSetState({
      ...localState,
      ...filterParams,
      vendor: filterParams?.vendor && {
        id: filterParams.vendor?.id,
        name: filterParams.vendor?.name,
      },
    });
  }, [filterParams]);
  const params = useCallback(() => {
    const newValue = {};
    for (const [key, value] of Object.entries(filterParams)) {
      if (value) {
        if (Array.isArray(value)) {
          newValue[key] = value.map((v) => v.value).join(',');
        } else if (typeof value === 'object') {
          newValue[key] = value.id;
        } else if (!value) {
          newValue[key] = null;
        } else {
          newValue[key] = value;
        }
      }
    }
    return newValue;
  }, [filterParams]);

  const {
    data: paynentMethodData,
    isLoading: isPaymentMethodLoading,
    isRefetching,
  } = useGetHook({
    queryKey: ['payment-method', `${JSON.stringify(filterParams)}`],
    url: APIS.PAYMENT_METHOD,
    params: { ...params(), is_active: true },
  });

  const isStaffFilter = usePermission({allowedPermissions:['can_filter_by_staff']})
    console.log(isStaffFilter)

  return (
    <div className={tw`mb-[50px]`}>
          <Card>
            <>
              <div className={tw`flex justify-between`}>
                <div
                  className={tw`uppercase text-primary  font-semibold cursor-pointer mx-2 pt-2`}
                >
                  Filter
                </div>
                <button
                  className={tw` font-semibold cursor-pointer mx-2 pt-2`}
                  onClick={handleReset}
                >
                  Reset
                </button>
              </div>

              <div className={tw`grid grid-cols-3 gap-x-8 px-4 pb-2`}>
                {clientType?.type == 'cargo' ? (
                  <InternationalFilter
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    getValues={getValues}
                    clearErrors={clearErrors}
                    setDate={setDate}
                    control={control}
                    adminOnly={!currentUserProfile?.is_superuser}
                  />
                ) : (
                  <Filter
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    getValues={getValues}
                    clearErrors={clearErrors}
                    setDate={setDate}
                    control={control}
                    adminOnly={!currentUserProfile?.is_superuser}
                  />
                )}
              </div>
            </>
          </Card>


      <div className={tw`flex justify-end`}>
        <button
          type='button'
          disabled={isLoading}
          onClick={() => handleClearCache()}
          className={tw`text-primary mb-2 mr-2 font-semibold focus:outline-none`}
        >
          Refresh
        </button>
      </div>
      <div className={tw`grid grid-cols-4 gap-x-8`}>
        {gridData?.map((item: any, index: number) => (
          <Fragment key={index}>
            <GridCard
              item={item}
              onClick={handleOnClickGrid}
              date={date}
              props={params()}
              activeCard={activeCard}
            />
          </Fragment>
        ))}
      </div>
      <StatusList
        paynentMethodData={paynentMethodData}
        filterParams={params()}
        register={register}
        setValue={setValue}
        getValue={getValues}
        isPaymentMethodLoading={isPaymentMethodLoading || isRefetching}
        date={date}
        selectedfilterParams={cardFilterParams}
        clientType={clientType}
      />
    </div>
  );
};

export default Dashboard;
